import { maskitoParseNumber } from '@maskito/kit';
import { z } from 'zod';

export { maskitoParseNumber };
export const getRechargeModalSchema = () =>
  z.object({
    amount: z.string().refine((amount) => maskitoParseNumber(amount) >= 10, { message: 'Error.At least ฿10' }),
    step: z.enum(['input', 'confirm'])
  });
